// extracted by mini-css-extract-plugin
module.exports = {"HeaderText":"TipList_HeaderText___REk_","TipList":"TipList_TipList__Wn4MA","Select":"TipList_Select__hgUZ6","CreateNew":"TipList_CreateNew__x2YmK"};